import { Component } from '@angular/core';

@Component({
  selector: 'gc-modal-sidebar',
  templateUrl: './modal-sidebar.component.html',
  styleUrls: ['./modal-sidebar.component.scss'],
})
export class ModalSidebarComponent {}
